// Revisado: 2026-02-21 [I18n Scan] - [Meta SEO]
import React from 'react';
import { useTranslation } from 'react-i18next';
import GameLobby from '../../common/GameLobby';
import GuessWhoBoard from './GuessWhoBoard';
import SEO from '../../../../components/shared/SEO';

export const metadata = {
    id: 'guess-who',
    title_key: 'GuessWho.meta_title',
    desc_key: 'GuessWho.meta_desc',
    icon: '🕵️‍♀️',
    color: 'teal'
};

const GuessWho = () => {
    const { t } = useTranslation();

    return (
        <>
            <SEO title={t('MetaGuessWho.title')} description={t('MetaGuessWho.description')} />
            <GameLobby
                gameId="guess-who"
                GameBoardComponent={GuessWhoBoard}
            />
        </>
    );
};

export default GuessWho;
